import { attach, createEffect, StoreValue } from "effector";
import { buy } from "sdk/fps/buy";
import { $connection } from "state/connection";
import { $store } from "state/store";
import { $wallet } from "state/wallet";
import { IArt } from "../artworks";
import { IFixedPrice } from "./types";

interface IBuyProps {
  sale: IFixedPrice;
  gatingArtwork?: IArt;
}

export const purchaseFpFx = attach({
  effect: createEffect(
    async ({
      sale,
      gatingArtwork,
      wallet,
      connection,
      store,
    }: IBuyProps & {
      connection: StoreValue<typeof $connection>;
      wallet: StoreValue<typeof $wallet>;
      store: StoreValue<typeof $store>;
    }) => {
      if (!store) {
        throw new Error("Empty store");
      }

      if (!wallet) {
        throw new Error("Empty wallet");
      }
      return await buy({
        connection,
        wallet,
        sale,
        store: store.storeFpsId,
        gatingArtwork,
      });
    }
  ),
  source: {
    wallet: $wallet,
    connection: $connection,
    store: $store,
  },
  mapParams: (params: IBuyProps, sources) => ({ ...params, ...sources }),
});
